if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoSlideInterval = parseInt(this.dataset.autoSlide) || 0;
      this.autoSlideTimer = null;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          this.resetAutoSlide();
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          this.resetAutoSlide();
        });
      }

      this.startAutoSlide();

    }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction == 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled')
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled')
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

    startAutoSlide() {
      if ( this.autoSlideInterval > 0 && this.length > 1 ) {
        this.autoSlideTimer = setInterval(() => {
          this.changeSlide('next');
        }, this.autoSlideInterval * 1000);
      }
    }

    resetAutoSlide() {
      if ( this.autoSlideTimer ) {
        clearInterval(this.autoSlideTimer);
        this.autoSlideTimer = null;
      }
      this.startAutoSlide();
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}